// @flow strict
import React from 'react';
import { Link } from 'gatsby';
import Author from './Author';
import Comments from './Comments';
import Content from './Content';
import Meta from './Meta';
import Tags from './Tags';
import ThemeToggle from '../ThemeToggle';
import styles from './Post.module.scss';
import type { Node } from '../../types';

type Props = {
  post: Node
};

const Post = ({ post }: Props) => {
  const { html } = post;
  const { tagSlugs, slug } = post.fields;
  const {
    tags, title, date, poetry, reflections, photograph
  } = post.frontmatter;

  // "All Articles" was shown above every piece, including poems and
  // reflections, and led out of the section the reader was in.
  let back = { label: 'All Articles', to: '/articles' };
  if (poetry) back = { label: 'All Poems', to: '/poetry' };
  else if (reflections) back = { label: 'All Reflections', to: '/reflections' };
  else if (photograph) back = { label: 'All Photographs', to: '/photographs' };

  return (
    <div className={styles['post']}>
      <Link className={styles['post__home-button']} to={back.to}>{back.label}</Link>

      {/* Balances the back button in the opposite corner. */}
      <div className={styles['post__theme-toggle']}>
        <ThemeToggle variant="switch" />
      </div>

      <div className={styles['post__content']}>
        <Content body={html} title={title} />
      </div>

      <div className={styles['post__footer']}>
        <Meta date={date} />
        {tags && tagSlugs && <Tags tags={tags} tagSlugs={tagSlugs} />}
        <Author />
      </div>

      <div className={styles['post__comments']}>
        <Comments postSlug={slug} postTitle={post.frontmatter.title} />
      </div>
    </div>
  );
};

export default Post;
